import {useEffect, useState} from "react";
import MainLayout from "../components/MainLayout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import {Eye} from "lucide-react";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import moment from "moment";
import "moment/locale/uz";
import {getInvoices} from "../services/invoice.service";

const RecieveInvoicePage = () => {
	const [invoices, setInvoices] = useState([]);
	const [searchText, setSearchText] = useState("");
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();

	const filteredData = invoices
		?.filter(
			(item) =>
				item.id.toString().includes(searchText.toLowerCase()) ||
				item.demands.some((demand) =>
					demand.toLowerCase().includes(searchText.toLowerCase())
				)
		)
		.sort((a, b) => b.id - a.id);

	useEffect(() => {
		const fetchInvoices = async () => {
			setLoading(true);
			try {
				const {invoices} = await getInvoices();
				setInvoices(invoices);
			} catch (error) {
				console.error("Error fetching invoices", error);
				toast.error("Накладнойлар юклашда хатолик");
			} finally {
				setLoading(false);
			}
		};

		fetchInvoices();
	}, []);

	return (
		<MainLayout header="Складга қабул қилиш">
			<div>
				<div className="relative flex items-center w-full mb-4">
					<i className="absolute text-gray-400 -translate-y-1/2 pointer-events-none pi pi-search left-3 top-1/2" />
					<InputText
						value={searchText}
						onChange={(e) => setSearchText(e.target.value)}
						className="w-full px-4 py-2 pt-3 border pl-9"
						placeholder="Накладной рақами ва заказ номери..."
					/>
				</div>
				<DataTable
					className="custom-row-border"
					value={filteredData}
					emptyMessage="Накладнойлар йўқ"
					rows={10}
					rowsPerPageOptions={[10, 25, 50]}
					loading={loading}>
					<Column
						className="w-[150px]"
						field=""
						header="N"
						headerClassName="w-fit"
						body={(_, {rowIndex}) => rowIndex + 1}
					/>
					<Column field="seh" header="Цех" className="w-[250px]" />
					<Column field="id" header="Накладной рақами" />
					<Column
						field="date"
						header="Накладной санаси"
						body={(rowData) => moment(rowData.date).format("D MMMM YYYY")}
					/>
					<Column
						field="demands"
						header="Заказлар"
						body={(rowData) =>
							Array.isArray(rowData.demands)
								? rowData.demands.join(", ")
								: rowData.demands
						}
					/>
					<Column
						field=""
						header="Амал"
						body={(rowData) => (
							<Eye
								className="cursor-pointer"
								onClick={() => navigate(`/invoice/${rowData.id}`)}
							/>
						)}
					/>
				</DataTable>
			</div>
		</MainLayout>
	);
};

export default RecieveInvoicePage;
